import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import renderCellMapper from './utils/render-cell-mapper';
import { DEFAULT_TABLE_CLASS_NAME } from '../../theme/constants/table';

const FingoTableCell = ({
  type,
  renderCell,
  row,
  valueGetter,
  width,
  align,
  sx,
  tableClassName,
  columnClassName,
}) => (
  <TableCell
    align={align}
    sx={{ minWidth: width, width, ...sx }}
    className={`${tableClassName} ${columnClassName || ''}`.trim()}
  >
    {renderCell ? renderCell({ row }) : renderCellMapper[type](valueGetter({ row }))}
  </TableCell>
);

FingoTableCell.propTypes = {
  type: PropTypes.string,
  renderCell: PropTypes.func,
  valueGetter: PropTypes.func,
  width: PropTypes.number,
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  sx: PropTypes.shape({
  }),
  tableClassName: PropTypes.string,
  columnClassName: PropTypes.string,
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
};

FingoTableCell.defaultProps = {
  type: 'string',
  renderCell: null,
  valueGetter: () => {},
  width: null,
  align: 'inherit',
  sx: {},
  tableClassName: DEFAULT_TABLE_CLASS_NAME,
  columnClassName: '',
};

export default FingoTableCell;
